<template>
  <div
    class="flex min-h-screen"
    :class="{ 'theme-dark': !nightMode, content: nightMode }"
  >
    <Sidebar
      class="w-1/6 hidden lg:block"
      :nightMode="nightMode"
      :style="[pdfActive ? { display: 'none' } : {}]"
    />
    <div
      class="containerHome w-full lg:w-5/6 absolute right-0 top-0 bottom-0 left-0 h-screen flex flex-col lg:left-auto"
    >
      <Navbar
        :nightMode="nightMode"
        :style="[pdfActive ? { display: 'none' } : {}]"
      />
      <SubNavbar
        :nightMode="nightMode"
        :style="[pdfActive ? { display: 'none' } : {}]"
      />
      <div
        class="content"
        :style="$isMobile() || pdfActive ? 'margin-top:0;' : 'margin-top:7rem;'"
        :class="{
          'theme-dark': !nightMode,
          'h-full': !isSafari,
          content: nightMode,
        }"
      >
        <router-view
          :style="[pdfActive ? { position: 'fixed', left: '10px' } : {}]"
          @pdfmode="pdfmode"
          :nightMode="nightMode"
          :selectedHub="selectedHub"
          :selectedCluster="selectedCluster"
        />
      </div>
    </div>
  </div>
</template>
<script>
/**
 * Vista de Home que contiene los componentes Navbar, Sidebar y Subnavbar
 */
import Navbar from "@/components/Navbar.vue";
import Sidebar from "@/components/Sidebar.vue";
import SubNavbar from "@/components/SubNavbar.vue";

export default {
  components: {
    Navbar,
    Sidebar,
    SubNavbar
  },
  data() {
    return {
      /**
       * nightMode: retorna true o false dependiendo si está en modo noche o no
       * selectedHub: hub seleccionado por defecto
       * selectedCluster: cluster seleccionado por defecto
       * pdfActive: si está en true muestra la vista de carga antes de mostrar el pdf si no muestra la vista normal
       * isSafari: variable para poder modificar el estilo en caso de que el navegador sea safari
       */
      nightMode: JSON.parse(sessionStorage.getItem("nightMode")) || false,
      selectedHub: 0,
      selectedCluster: 0,
      pdfActive: false,
      isSafari: /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
    };
  },
  async beforeMount() {
    /**
     * Recibe las props para determinar si está en nightMode
     */
    this.$root.$on("theme", nightMode => {
      this.nightMode = nightMode;
    });
    /**
     * Recibe las props para determinar el id seleccionado del hub
     */
    this.$root.$on("selectedHub", selectedHub => {
      this.selectedHub = selectedHub;
    });
    /**
     * Recibe las props para determinar el id seleccionado del cluster
     */
    this.$root.$on("selectedCluster", selectedCluster => {
      this.selectedCluster = selectedCluster;
    });
  },
  methods: {
    pdfmode(val) {
      this.pdfActive = val;
    }
  }
};
</script>

<style scoped>
.containerHome {
  height: min-content;
}
.pdfMode {
  display: none;
}
</style>